import { GET_MEDIA, REMOVE_MEDIA, LOGOUT } from "../types";

const initialState = [];

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_MEDIA: {
      return action.payload;
    }

    case REMOVE_MEDIA: {
      return state.filter((m) => m.id !== action.payload);
    }

    case LOGOUT: {
      return initialState;
    }

    default:
      return state;
  }
};
